import config from "../config";

let baseURL = config.baseURL

const fetchConfig = (basePath,method="GET",params=null,payload) =>{
    return new Promise((resolve,reject)=>{
    let path = baseURL + basePath
    let queryString = ""
    if(params){
        queryString = new URLSearchParams(params).toString();
    }
    const url = `${path}${queryString ? `?${decodeURIComponent(queryString)}` : ''}`;
    const headers ={
        "Content-Type": "application/json",
        "Authorization": `${localStorage.getItem('access_token')}`,
    } 
    fetch(url,{
            method,
            headers,
            ...(method !== "GET" && { body: JSON.stringify(payload) }),
        })
        .then(async(response) => {
            if (!response.ok) {
                if (response.status === 401) {
                    // Handle 401 Unauthorized
                    console.log("Unauthorized! Redirecting to login...");
                    localStorage.removeItem('token'); 
                    window.location.href = "/login";
                }
                let error =  new Error(`HTTP error! status: ${response.status}`);
                error.data = await response.json()
                throw error
            }
            return response.json();
        })
        .then((data) => {
            resolve(data)
        })
        .catch((error) => {
            console.error("Fetch Error:", error);
            reject(error.data)
        });
    })
}

export const getAgencyPerformance = (data) =>{
    return new Promise((resolve,reject)=>{
        console.log("request data : ",data);
        const today = new Date();
        const slab = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}`;
        let params = {
            slab : slab
        }
        if(data.slab !== undefined) params["slab"] = data?.slab
        if(data.agency_id !== undefined) params["agency_id"] =  data?.agency_id.join(",")
        fetchConfig("collections-v2/get_performance","GET",params).then(res=>{
            console.log("res res",res);
            resolve(res)
        }).catch(err=>{
            console.log("error :",err);
            reject(err)
        })
    })
}

export const getUserSettlementEmail = (student_id) =>{
    return new Promise((resolve,reject)=>{
        console.log("request student_id : ",student_id);
        if(!student_id) reject("no student id found")
        let params = {
            student_id : student_id
        }
        fetchConfig("collections-v1/get_settlement_email","GET",params).then(res=>{
            console.log("res res",res);
            resolve(res)
        }).catch(err=>{
            console.log("error :",err);
            reject(err)
        })
    })
}

export const updateUserSettlementEmail = (student_id,email) =>{
    return new Promise((resolve,reject)=>{
        console.log("request student_id : ",student_id);
        if(!student_id) reject("no student id found")
        let payload = {
            student_cog_id : student_id,
            email : email,
        }
        fetchConfig("collections-v1/change_settlement_email","POST",null,payload).then(res=>{
            console.log("res res",res);
            resolve(res)
        }).catch(err=>{
            console.log("error :",err);
            reject(err)
        })
    })
}

export const getSettlementPaymentOptions = () =>{
    return new Promise((resolve,reject)=>{
        fetchConfig("collections-v1/get_settlement_options","GET",null).then(res=>{
            console.log("res res",res);
            resolve(res)
        }).catch(err=>{
            console.log("error :",err);
            reject(err)
        })
    })
}

export const switcchSettlementPayment = (mode) =>{
    return new Promise((resolve,reject)=>{
        let params = {mode}
        fetchConfig("collections-v1/switch_settlement_payment","GET",params).then(res=>{
            console.log("res res",res);
            resolve(res)
        }).catch(err=>{
            console.log("error :",err);
            reject(err)
        })
    })
}